/* Current-catalog cart recommendations. No automatic replacements or discounts. */
(function(root, factory){
  'use strict';
  var logic = factory();
  if (typeof module === 'object' && module.exports) module.exports = logic;
  if (!root || !root.document) return;
  root.GRIGMerch = logic;
  logic.mount(root);
})(typeof window === 'undefined' ? null : window, function(){
  'use strict';
  function positive(n){ return Number.isInteger(Number(n)) && Number(n) > 0; }
  function id(v){ return String(v == null ? '' : v); }
  function blocked(p, knownBox){
    var tags = Array.isArray(p.tags) ? p.tags.join(' ') : String(p.tags || '');
    return (!knownBox && (p.has_components || p.requires_components)) || p.requires_selling_plan || (p.selling_plan_groups || []).length > 0 ||
      /(^|[\s,/_-])(alcohol|alcoholic|alkohol|beer|bier|wine|wein|vin|spirit|liqueur)([\s,/_-]|$)/i.test(tags + ' ' + (p.type || p.product_type || '') + ' ' + (p.handle || ''));
  }
  function quantities(cart, eligibleOnly){
    var result = {};
    (cart.items || []).forEach(function(item){
      if (eligibleOnly && (item.selling_plan_allocation || item.parent_relationship)) return;
      if (positive(item.quantity)) result[id(item.variant_id || item.id)] =
        (result[id(item.variant_id || item.id)] || 0) + Number(item.quantity);
    });
    return result;
  }
  function allowed(v, quantity, existing){
    var rule = v.quantity_rule || {}, min = Number(rule.min || 1), increment = Number(rule.increment || 1);
    var maximum = rule.max == null ? Infinity : Number(rule.max);
    var stock = v.max_quantity == null ? Infinity : Number(v.max_quantity);
    var finalQuantity = (existing[id(v.id)] || 0) + quantity;
    return v.available === true && !v.requires_selling_plan && (!(v.requires_components || v.has_components) || v.knownBox === true) && Number.isInteger(v.price) && v.price > 0 &&
      positive(quantity) && finalQuantity >= min && finalQuantity <= maximum && finalQuantity <= stock &&
      positive(increment) && finalQuantity % increment === 0;
  }
  // One freshness rule for every surface that shows a price or a claim: a catalog is
  // quoted only within 30 s of the moment the loader stamped it (loadedAt). An
  // unstamped catalog, or one stamped in the future, is never fresh.
  var CATALOG_TTL = 30000, CATALOG_FETCH_TIMEOUT = 8000;
  function catalogFresh(data, now){
    var age = (now == null ? Date.now() : now) - (data && data.loadedAt);
    return !!data && Number.isFinite(data.loadedAt) && age >= 0 && age < CATALOG_TTL;
  }
  // One redraw rule for every surface that shows catalog prices: a container is redrawn
  // only when its markup changes, so a catalog refresh that decides the same offers
  // touches nothing. A redraw gives keyboard focus back to the same control, found again by
  // its key (card, kind and data keys). When the control is gone for now (an expired
  // catalog dropped it until the next one lands), focus goes to the fallback (a status
  // node) if it is drawn (scrolled into view), or else the control is remembered for a short while and
  // focused again by the redraw that brings it back, unless focus has moved on meanwhile.
  var FOCUSABLE='a[href],button,input,select,textarea,[tabindex]', LOST_FOCUS_MS=10000, lostFocus=null;
  function controlKey(node){
    var card=node.closest && node.closest('[data-merch-key]'), d=node.dataset || {};
    return [card ? card.dataset.merchKey : '',node.tagName,node.className,node.getAttribute('href') || '',
      d.merchAdd || '',d.gdrAction || '',d.gdrKey || '',d.offerAdd || ''].join('|');
  }
  // Keyboard focus is moved only onto what the shopper sees: the target is scrolled into the
  // visible part of the page and of the drawer's body.
  // A target with nothing drawn (an empty status) cannot be seen: focus is not moved there.
  function drawn(node){ var r=node.getBoundingClientRect(); return r.width>0 && r.height>0; }
  function focusNode(node){
    function show(){ if(node.ownerDocument.activeElement===node){ try { node.scrollIntoView({block:'nearest',inline:'nearest'}); } catch(_){} } }
    try { node.focus({preventScroll:true}); } catch(_){ return; }
    show(); var win=node.ownerDocument.defaultView; if(win && win.requestAnimationFrame)win.requestAnimationFrame(show);
  }
  function redraw(parent, nodes, fallback){
    if(parent.innerHTML===nodes.map(function(n){return n.outerHTML;}).join(''))return false;
    var doc=parent.ownerDocument, active=doc.activeElement, inside=!!active && active!==parent && parent.contains(active);
    var key=inside ? controlKey(active) : null;
    if(!inside && lostFocus && lostFocus.parent===parent){
      if((!active || active===doc.body) && Date.now()-lostFocus.at<LOST_FOCUS_MS)key=lostFocus.key;
      lostFocus=null;
    }
    parent.replaceChildren.apply(parent,nodes);
    if(key===null)return true;
    var match=Array.prototype.find.call(parent.querySelectorAll(FOCUSABLE),function(n){return controlKey(n)===key;});
    if(match && !match.disabled)focusNode(match);
    else if(inside){
      if(fallback && fallback.isConnected && drawn(fallback))focusNode(fallback);
      else lostFocus={parent:parent,key:key,at:Date.now()};
    }
    return true;
  }
  // The page config (grigOfferConfig) enables native offers; unreadable means it does not.
  function nativeConfigured(doc){
    try { var node=doc.getElementById('grigOfferConfig'), config=node && JSON.parse(node.textContent);
      return !!(config && config.native && typeof config.native==='object' && config.native.enabled===true); } catch(_){ return false; }
  }
  function catalog(seeds, live){
    var variants = {}, products = [], boxes = [];
    (seeds || []).forEach(function(seed){
      var source = seed.product || {}, p = live.find(function(item){ return item && id(item.id) === id(source.id); });
      var curatedBox=Array.isArray(seed.recipe) && seed.recipe.length>0 && positive(seed.boxVariantId);
      if (!p || blocked(p,curatedBox) || blocked(source,curatedBox) || !Array.isArray(p.variants)) return;
      var entry = {id:p.id, handle:p.handle, title:p.title, url:seed.url, variants:[], recipe:seed.recipe || []};
      p.variants.forEach(function(v){
        var metadata = (seed.variants || []).find(function(m){ return id(m.id) === id(v.id); });
        if (!metadata || !Number.isInteger(v.price) || v.price <= 0) return;
        var merged = Object.assign({}, metadata, v, {product:entry, image:metadata.image, url:metadata.url});
        // Ajax may omit unit measurements; retain the real measurement, then derive
        // its price from the refreshed variant price rather than yesterday's value.
        merged.unit_price_measurement = v.unit_price_measurement || metadata.unit_price_measurement;
        merged.unit_price = unitPrice(Object.assign({}, merged, {unit_price:v.unit_price}));
        variants[id(v.id)] = merged; entry.variants.push(merged);
      });
      products.push(entry);
      if (entry.recipe.length) {
        var recipe = {}, valid = true;
        entry.recipe.forEach(function(row){
          if (!positive(row.variantId) || !positive(row.quantity)) { valid = false; return; }
          recipe[id(row.variantId)] = (recipe[id(row.variantId)] || 0) + Number(row.quantity);
        });
        entry.recipe = recipe; entry.validRecipe = valid;
        entry.variant = entry.variants.find(function(v){ return id(v.id) === id(seed.boxVariantId); });
        entry.count = Object.values(recipe).reduce(function(sum, n){ return sum + n; }, 0);
        if (valid && entry.count > 1 && entry.count <= 20 && entry.variant) boxes.push(entry);
      } else entry.recipe = null;
    });
    boxes.forEach(function(box){
      box.validRecipe = box.validRecipe && Object.keys(box.recipe).every(function(key){
        return variants[key] && !variants[key].product.recipe;
      });
    });
    boxes=boxes.filter(function(box){return box.validRecipe;});
    boxes.forEach(function(box){box.variant.knownBox=true;});
    return {variants:variants, products:products, boxes:boxes};
  }
  function unitPrice(v){
    var m = v.unit_price_measurement;
    if (!m) return null;
    var units = {mg:0.001, g:1, kg:1000, ml:1, cl:10, l:1000};
    var quantity = Number(m.quantity_value) * units[m.quantity_unit];
    var reference = Number(m.reference_value || 1) * units[m.reference_unit];
    if (quantity > 0 && reference > 0) return Math.round(v.price * reference / quantity);
    return Number.isInteger(v.unit_price) ? v.unit_price : null;
  }
  function selection(kind, entries, extra){
    var sorted = entries.slice().sort(function(a,b){ return Number(a.variant.id) - Number(b.variant.id); });
    return Object.assign({kind:kind, entries:sorted,
      key:kind + ':' + sorted.map(function(e){ return e.variant.id + 'x' + e.quantity; }).join(','),
      price:sorted.reduce(function(sum,e){ return sum + e.variant.price * e.quantity; },0)},extra);
  }
  function campaignState(cart, policy, now){
    if (!policy || policy.enabled !== true || policy.verified !== true || !cart ||
        policy.qualifyingSubtotalBasis !== 'original_total_price' || policy.currency !== cart.currency ||
        !['EUR','CZK'].includes(cart.currency) || !positive(policy.threshold) ||
        !positive(policy.basePercent) || !positive(policy.bonusPercent) ||
        policy.basePercent >= policy.bonusPercent || policy.bonusPercent > 100 ||
        typeof policy.bonusDiscountTitle !== 'string' || !policy.bonusDiscountTitle.trim()) return null;
    var zoned = /(?:Z|[+-]\d{2}:\d{2})$/;
    if (!zoned.test(policy.startsAt || '') || !zoned.test(policy.endsAt || '')) return null;
    var start = Date.parse(policy.startsAt), end = Date.parse(policy.endsAt), at = Number(now == null ? Date.now() : now);
    if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start || at < start || at >= end) return null;
    var subtotal = Number(cart.original_total_price);
    if (!Number.isInteger(subtotal) || subtotal < 0) return null;
    var savings = 0;
    (cart.cart_level_discount_applications || []).forEach(function(application){
      if (application.type === 'automatic' && application.title === policy.bonusDiscountTitle &&
          Number.isInteger(application.total_allocated_amount) && application.total_allocated_amount > 0) {
        savings += application.total_allocated_amount;
      }
    });
    (cart.items || []).forEach(function(item){
      (item.line_level_discount_allocations || []).forEach(function(allocation){
        var application = allocation.discount_application || {};
        if (application.type === 'automatic' && application.title === policy.bonusDiscountTitle &&
            Number.isInteger(allocation.amount) && allocation.amount > 0) savings += allocation.amount;
      });
    });
    var reached = subtotal >= policy.threshold;
    return {threshold:policy.threshold,subtotal:subtotal,gap:Math.max(0,policy.threshold-subtotal),
      percent:policy.bonusPercent,reached:reached,progress:Math.min(1,subtotal/policy.threshold),
      actualSavings:reached && savings <= subtotal ? savings : 0};
  }
  function recommend(cart, data, threshold, currency, campaign, options){
    var opts=options || {}, mode=opts.mode || 'all';
    if (!cart || !Array.isArray(cart.items) || !data || !Array.isArray(data.boxes) ||
        !['EUR','CZK'].includes(currency) || cart.currency !== currency) return [];
    var context=data.products.find(function(p){return id(p.id)===id(opts.productId);});
    if (!cart.items.length && !context) return [];
    var existing=quantities(cart), singles={}, covered={}, offers=[], seen={};
    var contextVariant=data.variants[id(opts.variantId)];
    var looseCount=0;
    cart.items.forEach(function(line){
      var key=id(line.variant_id || line.id), v=data.variants[key];
      if(!v || !positive(line.quantity))return;
      if(v.product.recipe){Object.keys(v.product.recipe).forEach(function(k){covered[k]=true;});}
      else if(plainLine(line)){singles[key]=(singles[key] || 0)+Number(line.quantity);looseCount+=Number(line.quantity);covered[key]=true;}
    });
    if(context){
      if(context.recipe)Object.keys(context.recipe).forEach(function(k){covered[k]=true;});
      else if(contextVariant && id(contextVariant.product.id)===id(context.id))covered[id(contextVariant.id)]=true;
    }
    function signature(offer){return (offer.entries || []).map(function(e){return id(e.variant.id)+'x'+e.quantity;}).sort().join(',');}
    function add(offer){
      if(!offer)return;
      var key=signature(offer) || offer.key;
      if(seen[key])return;seen[key]=true;offers.push(offer);
    }
    function singleCandidates(){
      return Object.values(data.variants).filter(function(v){return !v.product.recipe && allowed(v,1,existing);})
        .sort(function(a,b){return Number(!!covered[id(a.id)])-Number(!!covered[id(b.id)]) || a.price-b.price || Number(a.id)-Number(b.id);});
    }
    function companion(){
      var variant=singleCandidates()[0];
      return variant && selection('companion',[{variant:variant,quantity:1}],{repeat:!!covered[id(variant.id)],fifth:looseCount===4});
    }
    var nextBoxes=[];
    data.boxes.forEach(function(current){
      if(context && mode==='upgrade' && id(current.id)!==id(context.id))return;
      var sources=cart.items.filter(function(line){return id(line.variant_id || line.id)===id(current.variant.id) && eligibleBoxLine(line,current);});
      var source=sources[0];
      if(source && sources.filter(function(line){return propertyKey(line.properties)===propertyKey(source.properties);}).length!==1)return;
      var contextOnly=!source && mode==='upgrade' && context && id(current.id)===id(context.id);
      if(!source && !contextOnly)return;
      // An unsafe/custom source in the cart must not be represented as a replacement.
      if(contextOnly && existing[id(current.variant.id)])return;
      data.boxes.forEach(function(next){
        if(next.count<=current.count || next.variant.price<=current.variant.price || !allowed(next.variant,1,existing))return;
        if(!Object.keys(current.recipe).every(function(k){return (next.recipe[k] || 0)>=current.recipe[k];}))return;
        if(source)nextBoxes.push({kind:'box',key:'box:'+source.key+':'+next.id,box:next,current:current,source:source,difference:next.variant.price-current.variant.price});
        else nextBoxes.push(selection('add_target',[{variant:next.variant,quantity:1}],{box:next,current:current,difference:next.variant.price-current.variant.price}));
      });
    });
    nextBoxes.sort(function(a,b){return a.box.count-b.box.count || a.difference-b.difference;});
    if(mode==='upgrade'){if(nextBoxes[0])add(nextBoxes[0]);return offers;}
    if(mode!=='companion'){
      var completions=[];
      data.boxes.forEach(function(box){
        if(existing[id(box.variant.id)])return;
        var entries=[],owned=0,missing=0,possible=true;
        Object.keys(box.recipe).forEach(function(key){
          var required=box.recipe[key], quantity=Math.max(0,required-(singles[key] || 0));
          owned+=Math.min(required,singles[key] || 0);missing+=quantity;
          if(quantity){var variant=data.variants[key];if(!variant || !allowed(variant,quantity,existing))possible=false;else entries.push({variant:variant,quantity:quantity});}
        });
        if(possible && owned>0 && missing>0 && missing<=2)completions.push(selection('completion',entries,{box:box,owned:owned,missing:missing}));
      });
      completions.sort(function(a,b){return a.missing-b.missing || b.owned-a.owned || a.price-b.price;});
      add(completions[0]);
      // A small concrete next step must not disappear because the full shipping gap is too large.
      if(looseCount>0 && looseCount<5)add(companion());
      var quote=opts.offerState, goal=quote && quote.projection && quote.projection.active && quote.nextGoal;
      var modeledBF=goal && goal.kind==='bf' && !goal.reached;
      var shipping=quote && quote.shipping;
      // Native mode claims a shipping gap only from the engine's verified native amount
      // (never the theme threshold), and only for a selection its projection proves.
      var native=opts.native===true;
      var gap=native ? (shipping && !shipping.reached ? shipping.gap : 0) :
        modeledBF ? goal.gap : campaign ? campaign.gap : shipping ? shipping.gap : Number(threshold)-Number(cart.total_price);
      var kind=native ? 'shipping' : modeledBF ? 'goal' : campaign ? 'campaign' : 'shipping';
      if(Number.isInteger(gap) && gap>0){
        var candidates=Object.values(data.variants).filter(function(v){
          var box=data.boxes.find(function(b){return id(b.id)===id(v.product.id);});
          return (!v.product.recipe || (box && id(box.variant.id)===id(v.id))) && allowed(v,1,existing);
        });
        var combinations=[];
        function offer(entries){
          if(!entries.every(function(e){return allowed(e.variant,e.quantity,existing);}))return;
          var candidate=selection(kind,entries,{gap:gap,preview:!!(quote && quote.projection && quote.projection.active)});
          if(native){
            // No projection (a code, an unknown discount, an unresolved line): no claim.
            var total=typeof opts.projectNative==='function' ? opts.projectNative(entries) : null;
            if(!Number.isSafeInteger(total) || total<shipping.threshold)return;
          }else if(typeof opts.project==='function' && quote && quote.projection && quote.projection.active && (modeledBF || shipping)){
            var after=opts.project(entries);
            if(!after || (modeledBF ? !(after.nextGoal && after.nextGoal.kind==='bf' && after.nextGoal.reached) : !(after.shipping && after.shipping.reached)))return;
          }else if(kind==='shipping'){
            // Plain mode knows none of Shopify's automatic discounts and an addition can
            // trigger one (a fifth sachet), so a list price never proves the free shipping
            // gap closes: no selection is offered as closing it.
            return;
          }else if(candidate.price<gap)return;
          if(campaign)candidate.campaign=campaign;
          combinations.push(candidate);
        }
        candidates.forEach(function(v,i){
          offer([{variant:v,quantity:1}]);
          if(!v.product.recipe)offer([{variant:v,quantity:2}]);
          candidates.slice(i+1).forEach(function(other){offer([{variant:v,quantity:1},{variant:other,quantity:1}]);});
        });
        function unseenFlavours(candidate){
          var distinct=new Set();
          candidate.entries.forEach(function(entry){
            if(!entry.variant.product.recipe && !covered[id(entry.variant.id)])distinct.add(id(entry.variant.id));
          });
          return distinct.size;
        }
        combinations.sort(function(a,b){return a.price-b.price || unseenFlavours(b)-unseenFlavours(a) || b.entries.length-a.entries.length;});
        add(combinations[0]);
      }
      if(campaign && !offers.some(function(o){return o.kind==='campaign';}))add({kind:'campaign',key:'campaign:progress',campaign:campaign,entries:[],price:0});
      add(nextBoxes[0]);
    }
    if(mode==='companion' || !offers.length)add(companion());
    var cartBoxes=data.boxes.filter(function(box){return existing[id(box.variant.id)]>0;});
    var terminal=context && context.recipe ? context : cartBoxes.sort(function(a,b){return b.count-a.count;})[0];
    var hasLarger=terminal && data.boxes.some(function(next){return next.count>terminal.count && Object.keys(terminal.recipe).every(function(k){return (next.recipe[k] || 0)>=terminal.recipe[k];});});
    if(terminal && !hasLarger && (mode==='companion' || offers.length<3)){
      var gifts=data.boxes.filter(function(box){return allowed(box.variant,1,existing);})
        .sort(function(a,b){return Number(!!existing[id(a.variant.id)])-Number(!!existing[id(b.variant.id)]) || a.variant.price-b.variant.price;});
      if(gifts[0])add(selection('gift',[{variant:gifts[0].variant,quantity:1}],{box:gifts[0]}));
    }
    // Keep the meaningful next-box action visible alongside one small add-on and a gap offer.
    if(mode==='all' && nextBoxes[0] && offers.length>3){
      var upgrade=offers.find(function(o){return o.kind==='box';});
      return offers.slice(0,2).concat(upgrade ? [upgrade] : offers.slice(2,3));
    }
    return offers.slice(0,3);
  }
  function boxComparison(current,target,data){
    if(!current || !target || !data || !data.variants || !current.validRecipe || !target.validRecipe ||
        !current.recipe || !target.recipe)return null;
    var from=0,to=0,extra=[],valid=true;
    Object.keys(current.recipe).forEach(function(key){
      var quantity=Number(current.recipe[key]), variant=data.variants[key];
      if(!positive(quantity) || !variant || variant.product.recipe || !positive(target.recipe[key]) || Number(target.recipe[key])<quantity)valid=false;
      from+=quantity;
    });
    Object.keys(target.recipe).forEach(function(key){
      var quantity=Number(target.recipe[key]), variant=data.variants[key], difference=quantity-Number(current.recipe[key] || 0);
      if(!positive(quantity) || !variant || variant.product.recipe)valid=false;
      to+=quantity;
      if(difference>0 && variant)extra.push({variant:variant,quantity:difference});
    });
    if(!valid || !positive(from) || !positive(to) || to<=from || to>20 || !extra.length)return null;
    return {from:from,to:to,extra:extra,progress:from/to};
  }
  function offerEntries(offer){
    return Array.isArray(offer.entries) && offer.entries.length ? offer.entries :
      offer.box && offer.box.variant ? [{variant:offer.box.variant,quantity:1}] : [];
  }
  function requestedItems(formData){
    var result=[];
    if(formData.get('id'))result.push({id:formData.get('id'),quantity:Number(formData.get('quantity') || 1)});
    else {
      formData.forEach(function(value,key){
        var match=/^items\[(\d+)\]\[id\]$/.exec(key);
        if(match)result.push({id:value,quantity:Number(formData.get('items['+match[1]+'][quantity]') || 1)});
      });
      var ids=formData.getAll('items[][id]'), quantities=formData.getAll('items[][quantity]');
      ids.forEach(function(value,index){result.push({id:value,quantity:Number(quantities[index] || 1)});});
    }
    return result;
  }
  function analyticsItems(payload, requested){
    var rows = Array.isArray(payload && payload.items) ? payload.items : payload ? [payload] : [];
    var seen=new Set();
    return rows.map(function(item){
      var variantId = item.variant_id || item.id;
      if(seen.has(id(variantId)))return null;
      seen.add(id(variantId));
      var inputs = (requested || []).filter(function(row){ return id(row.id) === id(variantId); });
      var quantity = inputs.length ? inputs.reduce(function(sum,row){return sum+Number(row.quantity);},0) : Number(item.quantity || 1);
      var price = Number(item.final_price == null ? item.price : item.final_price);
      if (!positive(quantity) || !Number.isFinite(price) || price < 0 || !variantId) return null;
      return {item_id:id(item.product_id || variantId), item_variant:id(variantId),
        item_name:item.product_title || item.title || '', price:price/100, quantity:quantity};
    }).filter(Boolean);
  }
  function propertyKey(properties){return JSON.stringify(Object.keys(properties || {}).sort().map(function(key){return [key,properties[key]];}));}
  function safeLineContext(line){
    var keys=Object.keys(line && line.properties || {});
    var ownMarker=keys.length===1 && keys[0]==='_grig_swap' && /^grig-v1-[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(line.properties._grig_swap);
    var instructions=line && line.instructions || {}, nativeInstructions=line && line._grigNativeInstructions || {};
    return line && !line.selling_plan_allocation && !line.parent_relationship && (!keys.length || ownMarker) &&
      instructions.can_remove!==false && instructions.canRemove!==false && instructions.can_update_quantity!==false && instructions.canUpdateQuantity!==false &&
      nativeInstructions.canRemove!==false && nativeInstructions.canUpdateQuantity!==false;
  }
  function plainLine(line){
    return safeLineContext(line) && !line.has_components && !(line.item_components || []).length;
  }
  function mergeNativeEvidence(cart, evidence){
    if(cart && Array.isArray(cart.items))cart=Object.assign({},cart,{items:cart.items.map(function(line){var clean=Object.assign({},line);delete clean._grigNativeComponents;delete clean._grigNativeInstructions;return clean;})});
    if(!cart || !evidence || evidence.currency!==cart.currency || !Array.isArray(evidence.items) || !Array.isArray(cart.items) ||
       evidence.items.length!==cart.items.length)return cart;
    var rows=new Map();
    for(var i=0;i<evidence.items.length;i++){
      var row=evidence.items[i];
      if(!row || !row.key || rows.has(row.key) || !positive(row.variantId) || !positive(row.quantity) || !Array.isArray(row.components))return cart;
      rows.set(row.key,row);
    }
    if(!cart.items.every(function(line){var row=rows.get(line.key);return row && id(row.variantId)===id(line.variant_id || line.id) && row.quantity===line.quantity;}))return cart;
    return Object.assign({},cart,{items:cart.items.map(function(line){
      var row=rows.get(line.key);
      return Object.assign({},line,{_grigNativeComponents:row.components,
        _grigNativeInstructions:{canRemove:row.canRemove,canUpdateQuantity:row.canUpdateQuantity}});
    })});
  }
  function eligibleBoxLine(line, box){
    if(!box || !box.variant || id(line && (line.variant_id || line.id))!==id(box.variant.id) || !safeLineContext(line))return false;
    if(plainLine(line))return true;
    if(line.has_components!==true || !box.recipe || !Object.keys(box.recipe).length || !positive(line.quantity) ||
       !Array.isArray(line._grigNativeComponents) || !line._grigNativeComponents.length)return false;
    var observed={}, valid=true, marker=(line.properties || {})._grig_swap;
    line._grigNativeComponents.forEach(function(component){
      if(!component || !positive(component.variantId) || !positive(component.quantity) || component.sellingPlan || component.nested){valid=false;return;}
      var names=component.propertyNames || [];
      if(!Array.isArray(names) || names.some(function(name){return name!=='_grig_swap';}) ||
         (names.length && (!marker || component.swapMarker!==marker))){valid=false;return;}
      observed[id(component.variantId)]=(observed[id(component.variantId)] || 0)+Number(component.quantity);
    });
    var expected=Object.keys(box.recipe);
    return valid && Object.keys(observed).length===expected.length && expected.every(function(key){
      return positive(box.recipe[key]) && observed[key]===box.recipe[key]*line.quantity;
    });
  }
  function swapError(code){var error=new Error(code);error.code=code;return error;}
  // A step the client gave up (code 'timeout') may still be applied by Shopify after the
  // abort, so its outcome is unknown: the cart is read again with a short bounded backoff
  // until it shows the step, and a transaction with such a step never rolls anything back.
  var SWAP_CONFIRM_DELAYS=[1000,2000,4000];
  async function swapTransaction(spec, transport, validate){
    if(!spec || !spec.sourceKey || !spec.token || !positive(spec.sourceVariantId) || !positive(spec.targetVariantId) ||
       id(spec.sourceVariantId)===id(spec.targetVariantId) || !positive(spec.sourceQuantity))throw swapError('swap_changed');
    var before=await transport.read();
    var sourceProperties=propertyKey(spec.sourceProperties);
    var sourceBox={variant:{id:spec.sourceVariantId},recipe:spec.sourceRecipe}, targetBox={variant:{id:spec.targetVariantId},recipe:spec.targetRecipe};
    function identitySources(c){return (c.items || []).filter(function(line){return id(line.variant_id || line.id)===id(spec.sourceVariantId) && propertyKey(line.properties)===sourceProperties;});}
    function matchingSources(c){return identitySources(c).filter(function(line){return eligibleBoxLine(line,sourceBox);});}
    function sourceExact(c){return (c.items || []).find(function(line){return line.key===spec.sourceKey;});}
    function sourceResolved(c){var matches=matchingSources(c);return matches.length===1 && matches[0].quantity===spec.sourceQuantity ? matches[0] : null;}
    function sourceQuantity(c){return identitySources(c)
      .reduce(function(sum,line){return sum+Number(line.quantity || 0);},0);}
    function target(c){return (c.items || []).filter(function(line){return id(line.variant_id || line.id)===id(spec.targetVariantId) &&
      line.properties && line.properties._grig_swap===spec.token;});}
    function validSource(c){var line=sourceExact(c);return eligibleBoxLine(line,sourceBox) && id(line.variant_id || line.id)===id(spec.sourceVariantId) &&
      line.quantity===spec.sourceQuantity && propertyKey(line.properties)===sourceProperties && sourceQuantity(c)===spec.sourceQuantity;}
    async function observe(fallback){try{return await transport.read();}catch(_){return fallback && Array.isArray(fallback.items)?fallback:null;}}
    var uncertain=false;
    function timedOut(error){var hit=!!error && error.code==='timeout';if(hit)uncertain=true;return hit;}
    function pause(ms){return typeof transport.wait==='function' ? transport.wait(ms) : new Promise(function(resolve){setTimeout(resolve,ms);});}
    async function confirm(shows){
      for(var i=0;i<SWAP_CONFIRM_DELAYS.length;i++){
        await pause(SWAP_CONFIRM_DELAYS[i]);
        var seen=await observe();
        if(seen && shows(seen))return seen;
      }
      return null;
    }
    async function rollback(observed){
      if(uncertain)return false;
      var snapshot=observed || await observe();if(!snapshot)return false;
      var added=target(snapshot);if(!added.length)return true;
      if(added.length!==1 || added[0].quantity!==1)return false;
      var result;try{result=await transport.change(added[0].key,0);}catch(_){}
      var after=await observe(result);return !!after && target(after).length===0;
    }
    if(!validSource(before))throw swapError('swap_changed');
    if(validate)await validate(before);
    var addResult,addFailed=false,addTimedOut=false;
    try{addResult=await transport.add([{id:spec.targetVariantId,quantity:1,properties:{_grig_swap:spec.token}}]);}
    catch(error){addFailed=true;addTimedOut=timedOut(error);}
    var addedCart=addTimedOut ? await confirm(function(c){return target(c).length>0;}) : await observe();
    if(!addedCart)throw swapError('swap_review');
    var isolated=target(addedCart);
    if(!isolated.length)throw swapError(addFailed && !addTimedOut?'swap_add_error':'swap_review');
    if(isolated.length!==1 || isolated[0].quantity!==1)throw swapError('swap_review');
    if(!eligibleBoxLine(isolated[0],targetBox))throw swapError(await rollback(addedCart)?'swap_restored':'swap_review');
    var resolvedSource=sourceResolved(addedCart);
    if(!resolvedSource){
      throw swapError(await rollback(addedCart)?'swap_restored':'swap_review');
    }
    // Only the exact original line is decremented, and only after the isolated
    // replacement was observed. A lost HTTP response is resolved from cart truth.
    var changedCart,changeTimedOut=false;
    try{changedCart=await transport.change(resolvedSource.key,spec.sourceQuantity-1);}catch(error){changeTimedOut=timedOut(error);}
    var after=changeTimedOut ? await confirm(function(c){return sourceQuantity(c)!==spec.sourceQuantity;}) : await observe(changedCart);
    if(!after)throw swapError('swap_review');
    var remaining=sourceQuantity(after), replacement=target(after);
    if(remaining===spec.sourceQuantity-1 && replacement.length===1 && replacement[0].quantity===1 && eligibleBoxLine(replacement[0],targetBox) &&
       (remaining===0 || matchingSources(after).length===1)){
      return {items:[replacement[0]],removed:{variant_id:spec.sourceVariantId,quantity:1}};
    }
    if(remaining===spec.sourceQuantity){
      throw swapError(await rollback(after)?'swap_restored':'swap_review');
    }
    // Concurrent or unobservable edits are never "fixed" by deleting more goods.
    throw swapError('swap_review');
  }
  function mount(win){
    var doc = win.document, node = doc.getElementById('grigMerchData'), config;
    if (!node) return;
    try { config = JSON.parse(node.textContent); } catch (_) { return; }
    var slots = Array.from(doc.querySelectorAll('[data-grig-merch]'));
    var strings = config.strings || {}, state = null, revision = 0, pending = null, loaded = null, busy = false;
    var format;
    try { format = new Intl.NumberFormat(config.locale, {style:'currency',currency:config.currency,
      minimumFractionDigits:config.currency === 'CZK' ? 0 : 2,maximumFractionDigits:2}); } catch (_) { return; }
    function money(cents){ return format.format(cents/100); }
    function text(key, values){
      var value = strings[key] || '';
      Object.keys(values || {}).forEach(function(k){ value = value.replaceAll('{' + k + '}', String(values[k])); });
      return win.grigDecode ? win.grigDecode(value) : value;
    }
    function el(tag, cls, content){ var n=doc.createElement(tag); if(cls)n.className=cls; if(content)n.textContent=content; return n; }
    function safeURL(value){
      try { var u=new URL(value, win.location.href); return u.protocol === 'https:' && u.origin === win.location.origin ? u.href : ''; } catch (_) { return ''; }
    }
    function imageURL(value){
      try { var u=new URL(value, win.location.href); return u.protocol === 'https:' ? u.href : ''; } catch (_) { return ''; }
    }
    async function getCatalog(force){
      if (pending) return pending;
      if (!force && catalogFresh(loaded)) return loaded;
      // A product that does not answer within 8 s is left out (none of its prices is
      // quoted), so a hanging download never holds the catalog, or a change validating
      // with it, forever.
      pending = Promise.all(config.products.map(async function(seed){
        var path = (win.GRIG_ROUTES.root || '/').replace(/\/+$/,'') + '/products/' + encodeURIComponent(seed.product.handle) + '.js';
        var controller = win.AbortController ? new win.AbortController() : null;
        var timer = controller ? win.setTimeout(function(){ controller.abort(); }, CATALOG_FETCH_TIMEOUT) : 0;
        try { var response=await win.fetch(path,{headers:{Accept:'application/json'},cache:'no-store',signal:controller ? controller.signal : undefined});
          return response.ok ? await response.json() : null;
        } catch (_) { return null; }
        finally { win.clearTimeout(timer); }
      })).then(function(products){
        loaded=catalog(config.products, products); loaded.loadedAt=Date.now();
        watchExpiry(loaded); scheduleRefresh(loaded);
        // Every surface may re-quote with it at once (no blank between two catalogs).
        doc.dispatchEvent(new win.CustomEvent('grig:catalog-loaded',{detail:{catalog:loaded}}));
        return loaded;
      }).finally(function(){ pending=null; });
      return pending;
    }
    // A surface that shows catalog prices is on screen: the open drawer or popup, or a
    // merchandising or offer slot (a hidden one where it would appear) in the viewport.
    function pricedOnScreen(){
      var drawer=doc.getElementById('drawer'), popup=doc.getElementById('grigUpsell');
      if((drawer && drawer.classList.contains('open')) || (popup && popup.open))return true;
      var height=win.innerHeight || doc.documentElement.clientHeight;
      return Array.prototype.some.call(doc.querySelectorAll('[data-grig-merch],[data-grig-offer]'),function(node){
        if(drawer && drawer.contains(node))return false;
        var box=node.getClientRects().length ? node : node.parentElement, rect=box && box.getBoundingClientRect();
        return !!rect && rect.width>0 && rect.height>0 && rect.bottom>0 && rect.top<height;
      });
    }
    // While the page is visible and in use, the next catalog loads shortly before this one
    // expires, so legitimate offers never blink out, but only while a surface showing its
    // prices is on screen. Otherwise (hidden, idle or showing no price) nothing is polled:
    // the catalog expires and the next interaction that brings such a surface into view
    // starts a fresh one.
    var REFRESH_LEAD=5000, IDLE_LIMIT=120000, lastActivity=Date.now(), refreshTimer=0, activityTimer=0;
    function scheduleRefresh(data){
      win.clearTimeout(refreshTimer);
      refreshTimer=win.setTimeout(function(){
        if(loaded!==data || doc.visibilityState==='hidden' || Date.now()-lastActivity>IDLE_LIMIT || !pricedOnScreen())return;
        getCatalog(true).catch(function(){});
      },Math.max(0,data.loadedAt+CATALOG_TTL-REFRESH_LEAD-Date.now()));
    }
    function expiredInView(){
      activityTimer=0;
      if(loaded && !pending && !catalogFresh(loaded) && doc.visibilityState!=='hidden' && pricedOnScreen())getCatalog(false).catch(function(){});
    }
    // Activity with an expired catalog is checked once it settles (scroll and pointer events
    // come in bursts); the check reads where the page is then.
    ['pointerdown','keydown','touchstart','scroll','mousemove'].forEach(function(type){
      win.addEventListener(type,function(){
        lastActivity=Date.now();
        if(!activityTimer && loaded && !pending && !catalogFresh(loaded))activityTimer=win.setTimeout(expiredInView,200);
      },{capture:true,passive:true});
    });
    // A catalog that expires with no fresher one in its place is announced at once
    // (grig:catalog-expired): every surface drops what it priced, without waiting for
    // the next interaction. The next one that needs a catalog loads it.
    var expiryTimer=0;
    function watchExpiry(data){
      win.clearTimeout(expiryTimer);
      expiryTimer=win.setTimeout(function(){
        if(loaded!==data)return;
        if(catalogFresh(data)){watchExpiry(data);return;}
        if(state)render(state,null);
        doc.dispatchEvent(new win.CustomEvent('grig:catalog-expired'));
      },Math.max(0,data.loadedAt+CATALOG_TTL-Date.now()+1));
    }
    // The grig-native-cart-evidence section as HTML, or null (unanswered within 5 s, refused, too large).
    async function cartEvidence(){
      var controller=new win.AbortController(), timeout=win.setTimeout(function(){controller.abort();},5000);
      try {
        var url=new URL(win.GRIG_ROUTES.cart,win.location.href);
        url.searchParams.set('section_id','grig-native-cart-evidence');
        var preview=new URL(win.location.href).searchParams.get('preview_theme_id');
        if(preview && /^\d+$/.test(preview))url.searchParams.set('preview_theme_id',preview);
        var response=await win.fetch(url.href,{headers:{Accept:'text/html'},cache:'no-store',signal:controller.signal});
        if(!response.ok)return null;
        var html=await response.text();
        return html.length>500000 ? null : html;
      } catch(_){return null;}
      finally {win.clearTimeout(timeout);}
    }
    function mergeEvidenceHtml(cart,html){
      try {
        var evidenceNode=html && new win.DOMParser().parseFromString(html,'text/html').querySelector('script[data-grig-native-cart-evidence]');
        return evidenceNode ? mergeNativeEvidence(cart,JSON.parse(evidenceNode.textContent)) : null;
      } catch(_){return null;}
    }
    // early: the evidence fetched alongside the cart (grig.js getCart). It is used only when it
    // matches this cart line for line; otherwise (or without it) the evidence is fetched now.
    async function enrichCart(cart,early){
      if(!cart || !(cart.items || []).some(function(line){return line.has_components===true;}))return cart;
      var merged=early ? mergeEvidenceHtml(cart,await early) : null;
      if(merged && merged.items.every(function(line){return line.has_components!==true || !!line._grigNativeComponents;}))return merged;
      return mergeEvidenceHtml(cart,await cartEvidence()) || cart;
    }
    // The engine's shared offer-mode predicate, read once from the page config. Without the
    // engine (its asset did not load) a page whose config enables native offers is still
    // native, with no quote and so no shipping claim: nothing falls back to the theme
    // threshold or the legacy campaign.
    var offerModeCache=null;
    function offerMode(){
      if(offerModeCache===null && win.GRIGOfferEngine)offerModeCache=win.GRIGOfferEngine.pageOfferMode(doc,win.Shopify && win.Shopify.theme);
      return offerModeCache || (nativeConfigured(doc) ? 'native' : null);
    }
    // A box exchange released while its new box may still land is not offered again for a while.
    function currentOffers(cart,data,slot){
      return recommended(cart,data,slot).filter(function(offer){
        return !(offer.kind==='box' && win.GRIGCart && typeof win.GRIGCart.swapHeld==='function' && win.GRIGCart.swapHeld(offer.current.variant.id,offer.box.variant.id));
      });
    }
    function recommended(cart,data,slot){
      var contextId=slot && slot.dataset.merchContextProductId;
      var formVariant=doc.querySelector('form.lhero-buybar [name="id"], #grig-pdp-form [name="id"]');
      var opts={mode:slot && slot.dataset.merchMode || 'all',productId:contextId,variantId:formVariant && formVariant.value};
      var offers=win.GRIGOffers;
      opts.native=offerMode()==='native';
      if(opts.native){
        // The native engine decides: its quote (verified shipping amount) and its projection
        // of Shopify's total; the legacy campaign and the theme threshold claim nothing here.
        try { opts.offerState=offers ? offers.quote(cart,data) : null; } catch (_) { opts.offerState=null; }
        opts.projectNative=function(entries){
          try { return offers ? offers.projectNative(cart,data,entries.map(function(e){return {variant:e.variant,quantity:e.quantity};})) : null; }
          catch (_) { return null; }
        };
        return recommend(cart,data,null,config.currency,null,opts);
      }
      if(offers && win.GRIGOfferEngine){
        opts.offerState=offers.quote(cart,data);
        opts.project=function(entries){
          var hypothetical=cart;
          for(var i=0;i<entries.length;i++){
            hypothetical=win.GRIGOfferEngine.projectAdding(hypothetical,entries[i].variant,entries[i].quantity);
            if(!hypothetical)return null;
          }
          return win.GRIGOffers.quote(hypothetical,data);
        };
      }
      return recommend(cart,data,win.GRIG_FREE_SHIPPING,config.currency,campaignState(cart,win.GRIG_CAMPAIGN),opts);
    }
    var impressions=new Set(), impressionObserver=win.IntersectionObserver && new win.IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting && entry.intersectionRatio>=0.25){
          var meta=entry.target._grigOffer;
          if(meta){var key=meta.slot.dataset.merchSurface+':'+meta.offer.key+':'+(meta.offer.price != null ? meta.offer.price : meta.offer.box ? meta.offer.box.variant.price : 0);
            if(!impressions.has(key)){impressions.add(key);interaction('impression',meta.offer,meta.slot);}}
          impressionObserver.unobserve(entry.target);
        }
      });
    },{threshold:0.25});
    function interaction(event,offer,slot){
      var entries=offerEntries(offer);
      if(!entries.length)return;
      doc.dispatchEvent(new win.CustomEvent('grig:offer-interaction',{detail:{event:event,
        surface:slot.dataset.merchSurface || 'cart',kind:offer.kind,
        variantIds:entries.map(function(e){return id(e.variant.id);}),quantities:entries.map(function(e){return e.quantity;}),
        valueCents:entries.reduce(function(sum,e){return sum+e.variant.price*e.quantity;},0),currency:config.currency,
        contextProductId:slot.dataset.merchContextProductId || undefined}}));
    }
    function appendBoxComparison(card,offer,data){
      var comparison=boxComparison(offer.current,offer.box,data);
      if(!comparison)return;
      var box=el('div','gmch-box-comparison'), label=text('box_breadth',{current:comparison.from,target:comparison.to});
      box.append(el('p','gmch-box-breadth',label));
      var track=el('div','gmch-box-track'),fill=el('span');
      track.setAttribute('role','progressbar');track.setAttribute('aria-label',text('box_progress_label'));
      track.setAttribute('aria-valuemin','0');track.setAttribute('aria-valuemax',String(comparison.to));
      track.setAttribute('aria-valuenow',String(comparison.from));track.setAttribute('aria-valuetext',label);
      fill.style.width=(comparison.progress*100)+'%';track.append(fill);box.append(track,el('p','gmch-box-extra-label',text('box_extra')));
      var list=el('ul','gmch-box-extras');
      comparison.extra.forEach(function(entry){
        var variant=entry.variant,name=variant.product.title;
        if(variant.title && variant.title!=='Default Title')name+=' · '+variant.title;
        list.append(el('li','',entry.quantity+' × '+name));
      });
      box.append(list);card.append(box);
    }
    // The cart page body is stale while a change is pending or no read confirms it
    // (grig-cart.js): no card is priced for a cart the page cannot vouch for.
    function pageStale(){ return !!doc.querySelector('form.gcart-form.gcart-stale'); }
    // No read has confirmed what the cart must show now: a change in flight, a write that may
    // still land (another add could duplicate the goods), a period boundary.
    function unconfirmed(){ return !!(win.GRIGCart && win.GRIGCart.pending === true); }
    // A surface can leave out offer kinds and cap the count (data-merch-skip, data-merch-limit:
    // the /cart and drawer upsell budget, live audit); offers keep their priority order.
    function slotOffers(slot,offers){
      var skip=(slot.dataset.merchSkip || '').split(/[\s,]+/), limit=Number(slot.dataset.merchLimit);
      var shown=offers.filter(function(offer){return skip.indexOf(offer.kind)===-1;});
      return slot.dataset.merchLimit && Number.isInteger(limit) && limit>=0 ? shown.slice(0,limit) : shown;
    }
    function render(cart,data){
      // Only a fresh catalog prices a card, and only for a cart the page can vouch for.
      var usable=catalogFresh(data) && !pageStale() && !unconfirmed();
      slots.forEach(function(slot){
        var offers=usable ? slotOffers(slot,currentOffers(cart,data,slot)) : [];
        var list=slot.querySelector('[data-merch-offers]'), cards=[];
        slot.hidden=!offers.length && !slot.querySelector('[data-merch-status]').textContent && slot.querySelector('[data-merch-error]').hidden;
        offers.forEach(function(offer){
          var card=el('article','gmch-card gmch-card--'+offer.kind), heading=el('h3','gmch-title');
          card.dataset.merchKey=offer.key;
          if(offer.kind==='box'){
            heading.textContent=text('more_to_share'); card.append(heading);
            var link=el('a','gmch-box-link',offer.box.title), href=safeURL(offer.box.url);
            if(!href)return; link.href=href;
            if(offer.box.variant.image){var boxImage=el('img','gmch-box-image');boxImage.src=imageURL(offer.box.variant.image);boxImage.alt='';boxImage.width=88;boxImage.height=88;boxImage.loading='lazy';card.append(boxImage);}
            card.append(link,el('p','gmch-copy',text('sachets',{count:offer.box.count})+' · '+money(offer.box.variant.price)),
              el('p','gmch-note',text('box_difference',{amount:money(offer.difference)})));
            appendBoxComparison(card,offer,data);
            var compare=el('a','gmch-compare',text('view_box')); compare.href=href; card.append(compare);
            card.append(el('p','gmch-note',text('swap_price_note')));
            var exchange=el('button','gmch-add',text('swap_button',{source:offer.current.title,target:offer.box.title,amount:money(offer.difference)}));
            exchange.type='button';exchange.dataset.merchAdd=offer.key;exchange.disabled=busy || unconfirmed();card.append(exchange);
          } else {
            heading.textContent=text(offer.kind==='completion'?'completion_title':offer.kind==='campaign'?'campaign_title':offer.kind==='shipping'?'shipping_title':offer.kind==='goal'?'goal_title':offer.kind==='gift'?'gift_title':offer.kind==='add_target'?'larger_title':offer.repeat?'repeat_title':'companion_title',{percent:offer.campaign && offer.campaign.percent}); card.append(heading);
            // The drawer bar and the cart page's progress state the free shipping gap once; the shipping card does not repeat it.
            if(offer.kind!=='shipping')card.append(el('p','gmch-copy',offer.kind==='completion' ?
              text(offer.missing===1?'completion_one':'completion_many',{count:offer.missing,box:offer.box.title}) : offer.kind==='campaign' ?
              text(offer.campaign.actualSavings>0?'campaign_applied':offer.campaign.reached?'campaign_reached':'campaign_gap',{amount:money(offer.campaign.actualSavings || offer.campaign.gap),percent:offer.campaign.percent}) : offer.kind==='goal' ? text('goal_copy') : offer.kind==='gift' ? text('gift_copy') : offer.kind==='add_target' ? text('larger_copy',{source:offer.current.title,target:offer.box.title,amount:money(offer.difference)}) : text(offer.repeat?'repeat_copy':'companion_copy')));
            if(offer.kind==='campaign'){var track=el('div','gmch-campaign-track'),fill=el('i','gmch-campaign-fill');track.setAttribute('aria-hidden','true');fill.style.transform='scaleX('+offer.campaign.progress+')';track.append(fill);card.append(track);}
            if(offer.kind==='completion'){
              var meter=el('div','gmch-meter'); meter.setAttribute('aria-hidden','true');
              for(var i=0;i<offer.box.count;i++)meter.append(el('i',i<offer.owned?'is-filled':''));
              card.append(meter);
            }
            var products=el('ul','gmch-products');
            offer.entries.forEach(function(entry){
              var v=entry.variant, row=el('li','gmch-product'), source=imageURL(v.image);
              if(source){var img=el('img','gmch-image');img.src=source;img.width=56;img.height=56;img.alt='';img.loading='lazy';img.decoding='async';row.append(img);}
              var body=el('div','gmch-product-body'), name=el('a','gmch-product-name',v.product.title), href=safeURL(v.url);
              if(href)name.href=href;body.append(name);
              if(v.title && v.title!=='Default Title')body.append(el('span','gmch-flavour',v.title));
              body.append(el('span','gmch-product-price',entry.quantity+' × '+money(v.price)));
              // No price per kg on cart offer cards (owner, 24 Oct 2026).
              row.append(body);products.append(row);
            });
            card.append(products);
            if(offer.kind==='add_target')appendBoxComparison(card,offer,data);
            if(offer.kind==='completion')card.append(el('p','gmch-note',text('selection_note')));
            var button=el('button','gmch-add',text(offer.kind==='completion'?'add_missing':offer.kind==='add_target'?'add_larger':'add_selection',{amount:money(offer.price),target:offer.box && offer.box.title}));
            button.type='button';button.dataset.merchAdd=offer.key;button.disabled=busy || unconfirmed();
            button.setAttribute('aria-label',button.textContent+': '+offer.entries.map(function(e){return e.quantity+' × '+e.variant.product.title+' '+(e.variant.title==='Default Title'?'':e.variant.title);}).join(', '));
            if(offer.entries.length)card.append(button);
          }
          card._grigOffer={offer:offer,slot:slot};cards.push(card);
        });
        var nodes=cards.slice(), old=Array.from(list.children);
        if(offers.length){var disclosure=el('div','gmch-disclosure');disclosure.append(el('p','gmch-legal',text('price_note')),el('p','gmch-legal',text('allergens')));nodes.push(disclosure);}
        // Unchanged cards stay as they are (focus, impressions); new ones are observed.
        if(redraw(list,nodes,slot.querySelector('[data-merch-status]')) && impressionObserver){
          old.forEach(function(node){impressionObserver.unobserve(node);});
          cards.forEach(function(card){impressionObserver.observe(card);});
        }
      });
    }
    async function update(cart){
      state=cart; var request=++revision;
      var data=await getCatalog(false);
      if(request!==revision || busy)return;
      render(cart,data);
    }
    slots.forEach(function(slot){
      slot.addEventListener('click',async function(event){
        var button=event.target.closest('[data-merch-add]');
        if(!button || busy || !state || !win.GRIGCart || unconfirmed())return;
        var data=await getCatalog(false), offers=currentOffers(state,data,slot);
        var chosen=offers.find(function(o){return o.key===button.dataset.merchAdd;});
        if(!chosen)return;
        interaction('click',chosen,slot);
        var error=slot.querySelector('[data-merch-error]'), status=slot.querySelector('[data-merch-status]');
        // A wait for the cart is told once, by GRIGCart, next to the controls it holds; the
        // slot's own status says only how the action ended.
        error.hidden=true;status.textContent='';
        var options={
          source:'cart_'+chosen.kind,button:button,openDrawer:slot.dataset.merchSurface!=='cart',
          validate:async function(freshCart){
            var fresh=await getCatalog(true), match=currentOffers(freshCart,fresh,slot)
              .find(function(o){return o.key===chosen.key;});
            if(!match || (chosen.kind==='box' ? match.difference!==chosen.difference ||
               match.source.quantity!==chosen.source.quantity || match.box.variant.price!==chosen.box.variant.price : match.price!==chosen.price)) {
              throw swapError(chosen.kind==='box'?'swap_changed':'selection_changed');
            }
          }
        };
        var result=chosen.kind==='box' ? await win.GRIGCart.swapBox({
          sourceKey:chosen.source.key,sourceVariantId:chosen.current.variant.id,sourceQuantity:chosen.source.quantity,
          targetVariantId:chosen.box.variant.id,sourceProperties:chosen.source.properties || {},
          sourceRecipe:chosen.current.recipe,targetRecipe:chosen.box.recipe
        },options) : await win.GRIGCart.addItems(chosen.entries.map(function(e){return {id:e.variant.id,quantity:e.quantity};}),options);
        if(result && result.ok)interaction(chosen.kind==='box'?'upgrade':'add',chosen,slot);
        // An addition whose outcome is unknown is neither added nor failed: GRIGCart tells that
        // the cart is being checked. So does a swap left in review while a step of it may still
        // land (the wait, then how it ended): no second notice here.
        var unknown=!!result && result.unknown===true, told=!!result && result.reason==='swap_review' && result.reviewTold===true;
        status.textContent=result && result.ok ? text(chosen.kind==='box'?'swapped':'added') : '';
        if((!result || !result.ok) && !unknown && !told){
          error.textContent=text(chosen.kind==='box' && strings[result && result.reason] ? result.reason : 'error');error.hidden=false;
          if(result && result.reason==='swap_review'){
            var review=el('a','gmch-review',text('review_cart'));review.href=win.GRIG_ROUTES.cart;error.append(doc.createTextNode(' '),review);
          }
        }
        if(result && result.cart){await update(result.cart);}
        // The clicked card may disappear after completion. Keyboard focus goes to the notice
        // that says how it ended (the error, or the status), never to another offer's add: a
        // held or repeated key, or a later Space, would add that offer too. Nothing on screen
        // says it (the outcome is being checked): focus stays where it is.
        if(!doc.contains(button) || button.disabled){
          var focus=!error.hidden ? error : status.textContent ? status : null;
          if(focus===error)error.setAttribute('tabindex','-1');
          if(focus)focusNode(focus);
        }
      });
    });
    doc.addEventListener('grig:cart-updated',function(event){update(event.detail.cart);});
    doc.addEventListener('grig:catalog-loaded',function(){if(state && !busy)update(state);});
    doc.addEventListener('grig:offers-updated',function(event){if(event.detail && event.detail.cart)update(event.detail.cart);});
    doc.addEventListener('grig:variant',function(){if(state)update(state);});
    // Only the offers are busy while a change runs; the slot's status and error stay outside.
    doc.addEventListener('grig:cart-busy',function(event){
      busy=event.detail.busy;slots.forEach(function(slot){var offers=slot.querySelector('[data-merch-offers]');(offers || slot).setAttribute('aria-busy',String(busy));slot.querySelectorAll('[data-merch-add]').forEach(function(b){b.disabled=busy || unconfirmed();});});
      // A pending change makes the cart page stale: its cards go until a read confirms the cart.
      if(busy && pageStale())render(state,null);
      if(!busy && state)update(state);
    });
    // A cart that becomes pending or confirmed without a change is drawn again for it.
    doc.addEventListener('grig:cart-pending',function(){
      if(state && !busy)update(state);
    });
    // The cart could not be read back: nothing decided for the last known cart stays, and
    // nothing (a catalog refresh, the end of the change) re-renders it. The next successful
    // read (grig:cart-updated) quotes the cart Shopify holds.
    doc.addEventListener('grig:cart-load-error',function(){
      state=null;revision++;render(null,null);
    });
    // Keep a tab that crosses a scheduled boundary honest without polling.
    var boundaryTimer;
    function scheduleBoundary(){
      win.clearTimeout(boundaryTimer);
      var policy=win.GRIG_CAMPAIGN;
      if(!policy || policy.enabled!==true || policy.verified!==true)return;
      var now=Date.now(), next=[Date.parse(policy.startsAt),Date.parse(policy.endsAt)]
        .filter(function(time){return Number.isFinite(time)&&time>now;}).sort(function(a,b){return a-b;})[0];
      if(next)boundaryTimer=win.setTimeout(function(){if(state)update(state);scheduleBoundary();},Math.min(next-now+20,2147483647));
    }
    scheduleBoundary();
    doc.addEventListener('visibilitychange',function(){
      if(doc.visibilityState!=='visible')return;
      scheduleBoundary();
      // Back on the page: a catalog that is still fresh keeps serving (a hidden page skipped
      // its refresh, so it is planned again); an expired one is replaced by the next quote
      // that needs it (grig.js reads the cart again now) or by activity in view.
      if(loaded && catalogFresh(loaded))scheduleRefresh(loaded);
    });
    api.enrichCart=enrichCart;
    api.cartEvidence=cartEvidence;
    api.catalog=getCatalog;
    api.update=update;
  }
  var api={fresh:catalogFresh,redraw:redraw,boxComparison:boxComparison,offerEntries:offerEntries,catalogFrom:catalog,recommend:recommend,allowed:allowed,quantities:quantities,analyticsItems:analyticsItems,requestedItems:requestedItems,plainLine:plainLine,eligibleBoxLine:eligibleBoxLine,mergeNativeEvidence:mergeNativeEvidence,swapTransaction:swapTransaction,unitPrice:unitPrice,campaignState:campaignState,mount:mount};
  return api;
});
